enum TimingType {
    NextAvailable = 'NextAvailable',
    ThisWeek = 'ThisWeek',
    NextWeek = 'NextWeek',
}

export default TimingType;
